import { Fragment } from 'react';
import { coreExtensionData } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { customCatalogKindFilter } from './filters/customKindFilterExtension';

export const customCatalogPlugin = catalogPlugin.withOverrides({
  extensions: [
    catalogPlugin
      .getExtension('page:catalog')
      .override({
        factory(originalFactory, { inputs, config }) {
          return originalFactory({
            params: {
              loader: async () => {
                const { CustomCatalogPage } = await import(
                  './customCatalogPage'
                );

                /*
                 * Mantiene attivi e funzionanti tutti i filtri
                 * effettivamente collegati alla pagina Catalog.
                 *
                 * Quando un filtro viene disabilitato da configurazione,
                 * semplicemente non sarà presente nell'array.
                 */
                const filters = (inputs.filters ?? []).map(
                  (filter, index) => (
                    <Fragment key={`catalog-filter-${index}`}>
                      {filter.get(
                        coreExtensionData.reactElement,
                      )}
                    </Fragment>
                  ),
                );

                return (
                  <CustomCatalogPage
                    filters={filters}
                    pagination={config.pagination}
                  />
                );
              },
            },
          });
        },
      }),
    customCatalogKindFilter,
  ],
});
